var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M9.85547 3L5.85547 6.99H8.85547V14H10.8555V6.99H13.8555L9.85547 3ZM16.8555 17.01V10H14.8555V17.01H11.8555L15.8555 21L19.8555 17.01H16.8555Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
